import styled from "@emotion/styled"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import Grid from "@material-ui/core/Grid"

type TContainerProps = { children: JSX.Element | undefined }

export const StyledAppBar = styled(AppBar)`
  left: 0;
  display: flex;
  background-color: ${({ theme }) => theme.palette.primary.main};
  height: 7rem;
  padding: 0 ${({ theme }) => theme.spacing(2)};
  ${({ theme }) => theme.breakpoints.down("xs")} {
    height: 5.6rem;
  }
`

export const StyledGridItem = styled(Grid)`
  flex: 1;
`

export const Container = styled(Toolbar)<TContainerProps>`
  align-items: center;
  height: 100%;
  padding: 0;
`

export const LeftContainer = styled(Container)<TContainerProps>`
  justify-content: flex-start;
`

export const CenterContainer = styled(Container)<TContainerProps>`
  justify-content: center;
  text-align: center;
`

export const RightContainer = styled(Container)<TContainerProps>`
  justify-content: flex-end;
`
